//-----------------------------------------
// Countdown
//-----------------------------------------

function prependZero(number) {
  if (number <= 9) return "0" + number;
  else return number;
}

class Countdown extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      time: this.querySelector(".Countdown__Time"),
    };

    this.template = this.elements.time.textContent;

    this.currentDate = new Date(this.dataset.currentDate);

    this.startDate = new Date(this.dataset.startDate);
    this.endDate = new Date(this.dataset.endDate);

    this.remainingTimeInMilliseconds = this.endDate - this.currentDate;
  }

  connectedCallback() {
    if (
      this.isTimeWithinTimeFrame(this.currentDate, this.startDate, this.endDate)
    ) {
      this.remainingTimeInMilliseconds = this.endDate - this.currentDate;

      this.updateRemainingTime();

      this.elements.time.classList.remove("Countdown__Time--Loading");

      setInterval(() => {
        this.tick();
        this.updateRemainingTime();
      }, 1000);
    }
  }

  tick() {
    this.currentDate.setSeconds(this.currentDate.getSeconds() + 1);

    this.remainingTimeInMilliseconds = this.endDate - this.currentDate;
  }

  updateRemainingTime() {
    const days = Math.floor(
      this.remainingTimeInMilliseconds / (1000 * 60 * 60 * 24)
    );
    const hours = Math.floor(
      (this.remainingTimeInMilliseconds / (1000 * 60 * 60)) % 24
    );
    const minutes =
      Math.floor(this.remainingTimeInMilliseconds / (1000 * 60)) % 60;
    const seconds = Math.floor(this.remainingTimeInMilliseconds / 1000) % 60;

    const values = [
      prependZero(Math.max(days, 0)),
      prependZero(Math.max(hours, 0)),
      prependZero(Math.max(minutes, 0)),
    ];

    let i = 0;
    const timeString = this.template.replace(/00/g, () => values[i++] ?? "00");

    this.elements.time.textContent = timeString;
  }

  isTimeWithinTimeFrame(timeString, startTimeString, endTimeString) {
    const currentTime = new Date(timeString).getTime();
    const startTime = new Date(startTimeString).getTime();
    const endTime = new Date(endTimeString).getTime();

    return currentTime > startTime && currentTime < endTime;
  }
}

customElements.define("c-countdown", Countdown);

//-----------------------------------------
// Tooltip
//-----------------------------------------

class Tooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    tippy(this, {
      content: this.dataset.content,
      placement: "bottom",
      arrow: false,
      theme: "momento",
    });
  }
}

customElements.define("c-tooltip", Tooltip);

//-----------------------------------------
// Product Restock Alert
//-----------------------------------------

var ProductRestockAlert = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute('form')]?.addEventListener(
      'variant:change',
      this._onVariantChangedListener,
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute('form')]?.removeEventListener(
      'variant:change',
      this._onVariantChangedListener,
    );
  }
  _onVariantChanged(event) {
    const variantId = event.detail.variant ? event.detail.variant['id'] : null;
    Array.from(this.children).forEach((item) =>
      item.toggleAttribute('hidden', variantId !== parseInt(item.getAttribute('data-variant-id'))),
    );
  }
};

if (!window.customElements.get('product-restock-alert')) {
  window.customElements.define('product-restock-alert', ProductRestockAlert);
}

//-----------------------------------------
// Panel Calculator
//-----------------------------------------

var PanelCalculator = class extends HTMLElement {
  constructor() {
    super();
    this._onInputListener = this._onInput.bind(this);
  }
  connectedCallback() {
    this.querySelector('input').addEventListener('input', this._onInputListener);
  }
  _onInput(event) {
    const wallWidth = Number(event.target.value);
    const panelWidth = Number(this.dataset.panelWidth);
    const recommendation = Math.ceil(wallWidth / panelWidth);

    this.querySelectorAll('[data-input]').forEach((el) => {
      el.textContent = wallWidth;
    });
    this.querySelectorAll('[data-recommendation]').forEach((el) => {
      el.textContent = recommendation;
    });

    this.querySelector('.panel-calculator__result').removeAttribute('hidden');
  }
};

if (!window.customElements.get('panel-calculator')) {
  window.customElements.define('panel-calculator', PanelCalculator);
}

//-----------------------------------------
// Product Inspiration Gallery
//-----------------------------------------

var ProductInspirationGallery = class extends HTMLElement {
  constructor() {
    super();
    this._onVariantChangedListener = this._onVariantChanged.bind(this);
  }
  connectedCallback() {
    document.forms[this.getAttribute('form')]?.addEventListener(
      'variant:change',
      this._onVariantChangedListener,
    );
  }
  disconnectedCallback() {
    document.forms[this.getAttribute('form')]?.removeEventListener(
      'variant:change',
      this._onVariantChangedListener,
    );
  }
  _onVariantChanged(event) {
    if (!event.detail.product || !event.detail.variant) return;

    const option1Index = event.detail.product.options[0].values.findIndex(
      (value) => value === event.detail.variant.option1,
    );

    Array.from(this.querySelectorAll('[data-option1-index]')).forEach((item) =>
      item.toggleAttribute(
        'hidden',
        option1Index !== parseInt(item.getAttribute('data-option1-index')),
      ),
    );
  }
};

if (!window.customElements.get('product-inspiration-gallery')) {
  window.customElements.define('product-inspiration-gallery', ProductInspirationGallery);
}

//-----------------------------------------
// Experiments
//-----------------------------------------

const { pageType } = window.meta.page;

function triggerExperiment(experimentId) {
  window.experiments[`${experimentId}`] = true;
  window._conv_q.push(['executeExperiment', experimentId]);
}

(() => {
  //-----------------------------------------
  // Code that runs on all pages.
  //-----------------------------------------

  // Experiment: Hide unit price.

  const unitPriceElements = [...document.querySelectorAll('unit-price')];

  if (unitPriceElements.length > 0) {
    // Add intersection observer to check if any element is in viewport or about to enter the
    // viewport.

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            triggerExperiment('1004147531');

            // CLean up observer once experiment has been triggered.
            observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    unitPriceElements.forEach((element) => {
      observer.observe(element);
    });
  }
})();

if (pageType === 'product') {
  // Experiment: Add panel calculator to PDP

  const panelCalculatorElement = document.querySelector('panel-calculator');
  const quantitySelectorElement = document.querySelector('.product-info__quantity-selector');

  if (panelCalculatorElement && quantitySelectorElement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            triggerExperiment('1004178905');

            observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      },
    );

    observer.observe(quantitySelectorElement);
  }

  // Experiment: Add inspiration gallery to PDP

  const inspirationGalleryElement = document.querySelector('.inspiration-gallery');
  const featureChartSection = document.querySelector('.shopify-section--feature-chart');

  if (inspirationGalleryElement && featureChartSection) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            triggerExperiment('1004182217');

            observer.disconnect();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    );

    observer.observe(featureChartSection);
  }
}

if (pageType === 'collection') {
  //-----------------------------------------
  // Code that only runs on collection pages.
  //-----------------------------------------
}
